import { useIsElementTruncated } from '#pplx/frontend/aether/hooks/useIsElementTruncated.js';
import { useOverlay } from '#pplx/frontend/aether/internal/overlay/useOverlay.js';
import { useCallback, useEffect } from 'react';
/** Coordinates controlled or uncontrolled Tooltip state with trigger truncation. */
export function useTruncationAwareOpenState({ targetRef, open, onOpenChange, shouldOpenOnlyWhenTruncated, disabled, }) {
    const { isOpen: overlayIsOpen, handleOpenChange: handleOverlayOpenChange } = useOverlay({
        open,
        onOpenChange,
    });
    const isTriggerTruncated = useIsElementTruncated(targetRef, {
        enabled: shouldOpenOnlyWhenTruncated && !disabled,
    });
    const isTruncationGateOpen = !shouldOpenOnlyWhenTruncated || isTriggerTruncated;
    const isControlled = open !== undefined;
    // Controlled state is only masked by truncation, but an uncontrolled overlay must release its
    // shared ownership so it cannot reappear without a new open interaction.
    useEffect(() => {
        if (isControlled || isTruncationGateOpen || !overlayIsOpen)
            return;
        handleOverlayOpenChange(false);
    }, [handleOverlayOpenChange, isControlled, isTruncationGateOpen, overlayIsOpen]);
    const handleOpenChange = useCallback((nextOpen) => {
        if (nextOpen && !isTruncationGateOpen)
            return;
        handleOverlayOpenChange(nextOpen);
    }, [handleOverlayOpenChange, isTruncationGateOpen]);
    return {
        isOpen: isTruncationGateOpen && overlayIsOpen,
        handleOpenChange,
    };
}
//# sourceMappingURL=useTruncationAwareOpenState.js.map